import React from "react";
import PropTypes from "prop-types";
import { translate } from "@td/shared_utils";
import { DownArrowIcon } from "@td/ui";
import styles from "./styles.module.scss";
import classNames from "classnames";

const NotesCollapseButton = React.memo(({ isCollapsed, onClick }) => (
  <button
    type="button"
    className={classNames(styles.notesCollapseButton, {
      [styles.isOpened]: !isCollapsed,
    })}
    onClick={onClick}
  >
    {translate(
      null,
      "care_team_tasks.form.fields.notes",
      isCollapsed ? "show_more_button" : "show_less_button"
    )}

    <DownArrowIcon
      width={10}
      height={6}
      fill="#373939"
    />
  </button>
));

NotesCollapseButton.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NotesCollapseButton;
